import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';
import { microsoftConsumerSecurityClient } from 'client-factories/MicrosoftConsumerSecurityClientFactoryV1';
import { UserProfile } from 'mcsclient/models';
import { ApiCallResultStatus } from 'store/apiCallResultStatus';
import { createOneOffAsyncApiThunk } from 'store/reduxHelpers';

import { getDefaultUserProfileState, IUserProfileState } from './userProfileState';

const initialState: IUserProfileState = getDefaultUserProfileState();

// Get user profile
export const getUserProfileAsync = createOneOffAsyncApiThunk(
  'user/getUserProfileAsync',
  async () => {
    const response = await microsoftConsumerSecurityClient.userProfile.getUserProfile();
    return response as UserProfile;
  },
  ({ userProfile }) => userProfile.userProfileLoadingStatus
);

const handleGetUserProfileAsync = (builder: ActionReducerMapBuilder<IUserProfileState>): void => {
  builder
    .addCase(getUserProfileAsync.pending, (state) => {
      state.userProfileLoadingStatus = ApiCallResultStatus.LOADING;
    })
    .addCase(getUserProfileAsync.fulfilled, (state, action) => {
      state.userProfile = action.payload;
      state.userProfileLoadingStatus = ApiCallResultStatus.SUCCESS;
    })
    .addCase(getUserProfileAsync.rejected, (state, action) => {
      state.userProfileLoadingStatus = ApiCallResultStatus.FAILED;
      state.userProfileLoadError = action.error.message;
    });
};

export const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    handleGetUserProfileAsync(builder);
  },
});

export default userProfileSlice.reducer;
